import { NavLink } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ paddingTop: "7rem" }}>
      <h2>404 Page not found!</h2>

      <p>
        Go to the <NavLink to="/">Homepage</NavLink>.
      </p>
    </div>
  );
}
